"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  NavMenu: true
};
exports.default = exports.NavMenu = void 0;
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _Icon = require("../Icon/Icon");
var _IconButton = require("../IconButton/IconButton");
var _Tooltip = require("../Tooltip/Tooltip");
var _Button = require("../Buttons/Button");
var _Overlay = require("../Overlay/Overlay");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useTypeToFocus = require("../utils/useTypeToFocus");
var _navMenuUtils = require("./_navMenuUtils");
var _NavMenuBar = require("./NavMenuBar");
var _NavMenuGroup = require("./NavMenuGroup");
var _NavMenuItem = require("./NavMenuItem");
var _NavMenu = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu.css") : void 0);
var _NavMenu2 = require("./NavMenu.types");
Object.keys(_NavMenu2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _NavMenu2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NavMenu2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-nav-menu';
/**
 * **NavMenu** together with **NavMenu.Group**, **NavMenu.Item**,
 * or **NavMenu.Bar**; is used
 * to present a menu of navigational links. These can be
 * nested to create sub-menus.
 */
const NavMenu = exports.NavMenu = Object.assign(/*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const _h = addChildProps ? Object.assign(Object.assign({}, props), addChildProps(NavMenu, props)) : props,
    {
      show,
      showArrow = true,
      ariaCurrent,
      // @ts-expect-error from combined props
      ariaLabel,
      disabled,
      // @ts-expect-error from combined props
      buttonContents,
      buttonRef,
      buttonProps,
      children,
      className,
      overlayProps,
      hoverToOpen,
      // @ts-expect-error from combined props
      iconName,
      inNavMenuBar,
      menuAriaLabel,
      iconProps,
      listProps,
      maxHeight,
      moveFocusAndOpenNew,
      onShow,
      onHide,
      inToolbarOverflow,
      tooltipMessage,
      tooltipProps
    } = _h,
    wrapperProps = __rest(_h, ["show", "showArrow", "ariaCurrent", "ariaLabel", "disabled", "buttonContents", "buttonRef", "buttonProps", "children", "className", "overlayProps", "hoverToOpen", "iconName", "inNavMenuBar", "menuAriaLabel", "iconProps", "listProps", "maxHeight", "moveFocusAndOpenNew", "onShow", "onHide", "inToolbarOverflow", "tooltipMessage", "tooltipProps"]);
  const [isOpen, setIsOpen] = (0, _react.useState)(show);
  const classnames = _bind.default.bind(_NavMenu.default);
  const internalButtonRef = (0, _react.useRef)(null);
  const internalListRef = (0, _react.useRef)(null);
  const classes = classnames(`${CSS_BLOCK}__container`, className, {
    [`${CSS_BLOCK}--disabled`]: disabled
  });
  (0, _react.useEffect)(() => {
    if (children) {
      if (isOpen) {
        onShow === null || onShow === void 0 ? void 0 : onShow();
      } else if (isOpen === false) {
        onHide === null || onHide === void 0 ? void 0 : onHide();
      }
    }
  }, [isOpen, children]);
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleHide = () => {
    setIsOpen(false);
  };
  const hideAndFocus = focusDirection => {
    var _a, _b;
    handleHide();
    (_b = (_a = internalButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    if (focusDirection === 'left' || focusDirection === 'right') {
      moveFocusAndOpenNew === null || moveFocusAndOpenNew === void 0 ? void 0 : moveFocusAndOpenNew(internalButtonRef.current, focusDirection);
    }
  };
  // in toolbar overflow, pressing left should close
  // the nav menu and focus the trigger.
  const handleMenuKeydown = event => {
    if (inToolbarOverflow) {
      if ((0, _keycode.default)(event) === 'left') {
        hideAndFocus('');
      }
    }
  };
  const handleButtonKeyDown = event => {
    if (disabled) return;
    if (inToolbarOverflow) {
      // in toolbar overflow, pressing down on the nav menu button
      // should do nothing because down is reserved for tabbing to the next
      // item in the overflow menu
      if ((0, _keycode.default)(event) === 'down') return;
      // in toolbar overflow, pressing right on the nav menu button
      // should open it
      if ((0, _keycode.default)(event) === 'right') {
        event.preventDefault();
        setIsOpen(true);
      }
    }
    if (['enter', 'space', 'down'].includes((0, _keycode.default)(event))) {
      event.preventDefault();
      setIsOpen(!isOpen);
    }
  };
  const handleMouseEnter = () => {
    if (hoverToOpen) {
      setIsOpen(true);
    }
  };
  const handleMouseLeave = () => {
    if (hoverToOpen) {
      setIsOpen(false);
    }
  };
  const passChildProps = child => {
    // support both MenuButtonItem in NavMenu for help-portal
    // because we need to support actions and links in the same help menu
    if (child.displayName === 'NavMenuItem' || child.displayName === 'MenuButtonItem') {
      return {
        inToolbarOverflow,
        hideMainMenu: hideAndFocus,
        hoverToOpen,
        inNavMenuBar,
        level: 0
      };
    }
    return {};
  };
  const handlePopperMouseEnter = () => {
    if (hoverToOpen) {
      setIsOpen(true);
    }
  };
  const handlePopperMouseLeave = () => {
    if (hoverToOpen) {
      setIsOpen(false);
    }
  };
  const {
    handleTypeToFocus
  } = (0, _useTypeToFocus.useTypeToFocus)({
    focusCandidates: Array.from(((_a = internalListRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[role="menuitem"]')) || []),
    keyStrokeTimeout: 50,
    focusMatchingItem: _navMenuUtils.focusMatchingItem
  });
  const additionalButtonProps = {
    role: inNavMenuBar ? 'menuitem' : buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.role,
    disabled,
    allowFocusOnDisable: disabled,
    // In an a11y review with Vinay
    // he mentioned being able to focus on disabled
    // items will be a better experience for AT users.
    'aria-current': !!ariaCurrent || undefined,
    'aria-haspopup': true,
    'aria-expanded': isOpen,
    ref: buttonRef ? (0, _reactMergeRefs.default)([buttonRef, internalButtonRef]) : internalButtonRef,
    onMouseEnter: (0, _chainFunction.default)(handleMouseEnter, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onMouseEnter),
    onMouseLeave: (0, _chainFunction.default)(handleMouseLeave, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onMouseLeave),
    onClick: (0, _chainFunction.default)(handleToggle, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick),
    onKeyDown: (0, _chainFunction.default)(handleButtonKeyDown, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onKeyDown)
  };
  const button = /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({
    type: "link"
  }, buttonProps, additionalButtonProps, {
    className: classnames(`${CSS_BLOCK}__toggle`, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className, {
      [`${CSS_BLOCK}__toggle--current`]: !!ariaCurrent,
      [`${CSS_BLOCK}__toggle--disabled`]: !!disabled
    }),
    innerProps: Object.assign(Object.assign({}, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.innerProps), {
      className: classnames(`${CSS_BLOCK}__toggle-inner`, (_b = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.innerProps) === null || _b === void 0 ? void 0 : _b.className)
    }),
    innerTextClasses: classnames(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.innerTextClasses, `${CSS_BLOCK}__toggle-text`)
  }), buttonContents, showArrow && (/*#__PURE__*/_react.default.createElement(_Icon.Icon, Object.assign({
    ariaHidden: true,
    iconName: "arrow-2-s",
    forceSize: "xs-plus"
  }, iconProps))));
  const wrappedButton = tooltipMessage && !inToolbarOverflow && !isOpen ? (/*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, Object.assign({}, tooltipProps, {
    message: tooltipMessage
  }), button)) : button;
  const menuOverlay = /*#__PURE__*/_react.default.createElement(_Overlay.Overlay, Object.assign({
    popperPlacement: ['bottom-start', 'bottom-end', 'top-start', 'top-end', 'bottom', 'top']
  }, overlayProps, {
    show: isOpen,
    onShow: () => setIsOpen(true),
    innerDialogClassName: classnames(`${CSS_BLOCK}__inner-dialog`),
    onHide: handleHide,
    onClickOutside: event => (0, _navMenuUtils.handleOutsideClick)(event, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onClickOutside, handleHide),
    popperProps: Object.assign(Object.assign({
      role: 'presentation'
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps), {
      onMouseEnter: (0, _chainFunction.default)(handlePopperMouseEnter, (_c = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps) === null || _c === void 0 ? void 0 : _c.onMouseEnter),
      onMouseLeave: (0, _chainFunction.default)(handlePopperMouseLeave, (_d = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps) === null || _d === void 0 ? void 0 : _d.onMouseLeave),
      'data-overflow-flyout': 'true',
      'data-nui-widgets': 'menu-overlay'
    }),
    popperContentProps: Object.assign(Object.assign({}, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperContentProps), {
      className: classnames((_e = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperContentProps) === null || _e === void 0 ? void 0 : _e.className, `${CSS_BLOCK}__overlay`),
      style: Object.assign({
        maxHeight
      }, (_f = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperContentProps) === null || _f === void 0 ? void 0 : _f.style)
    }),
    targetComponent: buttonContents ? wrappedButton : (/*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({}, buttonProps, additionalButtonProps, {
      className: classnames(`${CSS_BLOCK}__toggleicon`, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className, {
        [`${CSS_BLOCK}__toggleicon--current`]: !!ariaCurrent,
        [`${CSS_BLOCK}__toggleicon--disabled`]: !!disabled
      }),
      innerProps: Object.assign(Object.assign({}, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.innerProps), {
        className: classnames(`${CSS_BLOCK}__toggle-inner`, (_g = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.innerProps) === null || _g === void 0 ? void 0 : _g.className)
      }),
      ariaLabel: ariaLabel,
      iconName: iconName
    }))),
    focusManagerProps: {
      nextKeyCode: _keycode.default.codes.down,
      previousKeyCode: _keycode.default.codes.up,
      trapWithTabbing: true,
      onlyContainedEvents: true,
      useHomeAndEndKeys: true
    }
  }), /*#__PURE__*/_react.default.createElement("ul", Object.assign({}, listProps, {
    role: "menu",
    className: classnames(CSS_BLOCK, listProps === null || listProps === void 0 ? void 0 : listProps.className),
    "aria-label": menuAriaLabel,
    onKeyDown: (0, _chainFunction.default)(handleTypeToFocus, handleMenuKeydown, listProps === null || listProps === void 0 ? void 0 : listProps.onKeyDown),
    ref: (listProps === null || listProps === void 0 ? void 0 : listProps.ref) ? (0, _reactMergeRefs.default)([listProps.ref, internalListRef]) : internalListRef
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, children)));
  return inNavMenuBar ? (/*#__PURE__*/_react.default.createElement("li", Object.assign({}, wrapperProps, {
    role: "none",
    ref: ref,
    className: classes
  }), menuOverlay)) : (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, wrapperProps, {
    ref: ref,
    className: classes
  }), menuOverlay));
}), {
  displayName: 'NavMenu',
  Bar: _NavMenuBar.NavMenuBar,
  Group: _NavMenuGroup.NavMenuGroup,
  Item: _NavMenuItem.NavMenuItem
});
var _default = exports.default = NavMenu;